"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledCardLineBreak = exports.StyledCardFooter = exports.StyledCardHeader = exports.StyledCardBody = exports.StyledCard = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const tokens_1 = require("../../styles/tokens");
// Here we are using SizeVariants because for responsive purposes, we will have to decrease to less than 1.5 which is the min of the CardSizeVariants
const responsivePadding = (spacing, breakpoint) => {
    if (spacing === 0) {
        return 0;
    }
    // In the tiny spacings, from desktop all the way down to small mobile the padding does not change
    if (spacing <= 1.5) {
        return tokens_1.SIZES[spacing];
    }
    // Paddings which change at different breakpoints (cases for 2 & 3 only!!)
    switch (breakpoint) {
        // Here we are saying that both 2 & 3 cannot jump to a SizeVariant lower than 1.5
        case tokens_1.BREAKPOINTS.xs:
        case tokens_1.BREAKPOINTS.sm:
            return tokens_1.SIZES[1.5];
        // We go down one size
        case tokens_1.BREAKPOINTS.md:
            if (spacing === 2) {
                return tokens_1.SIZES[1.5];
            }
            return tokens_1.SIZES[spacing - 1];
        // For desktop devices just return what was provided
        case tokens_1.BREAKPOINTS.lg:
        default:
            return tokens_1.SIZES[spacing];
    }
};
// Header and footer work slightly differently where top & bottom padding are slightly smaller than left & right
const workoutHeadFootTopBottomPadding = (spacing, breakpoint) => {
    // Set initial point of the top & bottom padding
    let newSpacing;
    switch (spacing) {
        case 0:
            newSpacing = 0;
            break;
        case 1.5:
            newSpacing = 1;
            break;
        case 2:
            newSpacing = 1.5;
            break;
        case 3:
        default:
            newSpacing = 2;
            break;
    }
    // with that work out the set top & bottom responsive paddings
    return responsivePadding(newSpacing, breakpoint);
};
exports.StyledCard = styled_components_1.default.div `
    ${tokens_1.TYPOGRAPHY.body.base}
    border-radius: ${tokens_1.BORDERS.radius};

    ${({ variant, isElevated }) => {
    if (variant === "dashed") {
        return `
                background-color: transparent;
                border: 2px dashed ${tokens_1.COLOURS.greyscale.metal};
            `;
    }
    const elevation = isElevated
        ? `box-shadow: ${tokens_1.SHADOWS.raised.medium.silver};`
        : "";
    return `
            background-color: ${tokens_1.COLOURS.greyscale.white};
            border: ${tokens_1.BORDERS.normal.silver};
            ${elevation}
        `;
}};
`;
exports.StyledCardBody = styled_components_1.default.div `
    padding: ${(props) => responsivePadding(props.spacing, tokens_1.BREAKPOINTS.xs)};

    @media all and (min-width: ${tokens_1.BREAKPOINTS.sm}) {
        padding: ${(props) => responsivePadding(props.spacing, tokens_1.BREAKPOINTS.sm)};
    }

    @media all and (min-width: ${tokens_1.BREAKPOINTS.md}) {
        padding: ${(props) => responsivePadding(props.spacing, tokens_1.BREAKPOINTS.md)};
    }

    @media all and (min-width: ${tokens_1.BREAKPOINTS.lg}) {
        padding: ${(props) => responsivePadding(props.spacing, tokens_1.BREAKPOINTS.lg)};
    }
`;
const HeaderFooterLayout = styled_components_1.default.div `
    ${(props) => props.backgroundColour
    ? `background-color: ${tokens_1.COLOURS.greyscale[props.backgroundColour]};`
    : ""};

    padding: ${(props) => `
        ${workoutHeadFootTopBottomPadding(props.spacing, tokens_1.BREAKPOINTS.xs)}
        ${responsivePadding(props.spacing, tokens_1.BREAKPOINTS.xs)}
    `};

    @media all and (min-width: ${tokens_1.BREAKPOINTS.sm}) {
        padding: ${(props) => `
            ${workoutHeadFootTopBottomPadding(props.spacing, tokens_1.BREAKPOINTS.sm)}
            ${responsivePadding(props.spacing, tokens_1.BREAKPOINTS.sm)}
        `};
    }

    @media all and (min-width: ${tokens_1.BREAKPOINTS.md}) {
        padding: ${(props) => `
            ${workoutHeadFootTopBottomPadding(props.spacing, tokens_1.BREAKPOINTS.md)}
            ${responsivePadding(props.spacing, tokens_1.BREAKPOINTS.md)}
        `};
    }

    @media all and (min-width: ${tokens_1.BREAKPOINTS.lg}) {
        padding: ${(props) => `
            ${workoutHeadFootTopBottomPadding(props.spacing, tokens_1.BREAKPOINTS.lg)}
            ${responsivePadding(props.spacing, tokens_1.BREAKPOINTS.lg)}
        `};
    }
`;
// Can add any Header vs. Footer custom styling here (i.e. background-color, etc.)
exports.StyledCardHeader = (0, styled_components_1.default)(HeaderFooterLayout) ``;
exports.StyledCardFooter = (0, styled_components_1.default)(HeaderFooterLayout) ``;
exports.StyledCardLineBreak = styled_components_1.default.hr `
    border: none;
    border-top: solid 1px ${tokens_1.COLOURS.greyscale.silver};
    margin-top: 0;
    margin-bottom: 0;
`;
//# sourceMappingURL=Card.styles.js.map